import {takeFirstDefinedForKeys} from 'powtoon-commons/utils'
import {getInitialWebVars} from 'powtoon-commons/utils/webvars'

const webvars = getInitialWebVars(({is_prod_env}) => is_prod_env)

const assignedWebVars = takeFirstDefinedForKeys({
  logzioId:           [ webvars.logzio_id, null ],
  logzioMetricsId:    [ webvars.logzio_metrics_id, 'LOGZIO_METRICS_ID_IS_MISSED' ],
  logzioUrl:          [ webvars.logzio_url, 'https://listener.logz.io:8091' ],
  min_log_level:      [ webvars.min_log_level, null ],
  appLevel:           [ webvars.APP_LEVEL, null ],
  userId:             [ webvars.userid, null ],
  clientIP:           [ webvars.client_ip, null ],
  brandingStyle:      [ webvars.branding_style, 'regular' ]
})

export default {
  getWebVars() {
    return assignedWebVars
  },

  getWebVar(propName) {
    return assignedWebVars[propName]
  }
}
